import { createApp } from 'vue';
import store from './store';
import router from './router';
import i18n from './i18n';
import Toast, { POSITION } from 'vue-toastification';

// 3rd party plugins
import 'bootstrap';
import 'jquery';
import 'datatables.net';
import 'datatables.net-bs5';
import 'lightbox2';

createApp({})
  .use(store)
  .use(router)
  .use(i18n)
  .use(Toast, { position: POSITION.BOTTOM_RIGHT })
  .mount('#app');
